import { createContext } from 'react';

const SupportContext = createContext();

export default SupportContext;
